import axios from "axios";
import _ from "lodash";
import { toast } from "react-toastify";

const basePathV1 = process.env.REACT_APP_API_URL + "/v1";
const config = { validateStatus: function (status) { return status < 500; } };

export const getAddress = postalCode => async dispatch => {
  try {
    const res = await axios.get(`${basePathV1}/address/${postalCode}`, config);
    if (res.status === 200) {
      return res.data
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};